<div class="content">
    <mat-card appearance="outlined">
        <mat-card-header>
            <mat-icon class="card-header-icon" mat-card-avatar>alarm</mat-icon>
            <mat-card-title>Scheduler</mat-card-title>
            <mat-card-subtitle>List of all scheduled configurations and run history</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <mat-tab-group>
                <mat-tab label="Schedules">
                    <mat-card appearance="outlined">
                        <mat-card-actions>
                            <button style="margin-left: 10px;" (click)="addNewSchedule()" mat-flat-button color="primary">New Schedule</button>
                        </mat-card-actions>
                        <mat-card-content>
                            <h1 *ngIf="!hasSchedules" class="center" style="color: lightgray">No Schedules found</h1>
                            <table *ngIf="hasSchedules" mat-table [dataSource]="schedules" class="mat-elevation-z8">
                                <ng-container matColumnDef="scheduleId">
                                    <th mat-header-cell *matHeaderCellDef> Build Id </th>
                                    <td mat-cell *matCellDef="let schedule"> {{schedule.id}} </td>
                                </ng-container>

                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef> </th>
                                    <td mat-cell *matCellDef="let schedule">
                                        <mat-icon *ngIf="schedule.status === scheduleStatusType.running" class="rotate-continous primary-color-icon" style="margin-right: 10px; vertical-align: middle;">settings_backup_restore</mat-icon>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="name">
                                    <th mat-header-cell *matHeaderCellDef> Name </th>
                                    <td mat-cell *matCellDef="let schedule"> {{schedule.scheduleName}} </td>
                                </ng-container>

                                <ng-container matColumnDef="description">
                                    <th mat-header-cell *matHeaderCellDef> Description </th>
                                    <td mat-cell *matCellDef="let schedule"> No description </td>
                                </ng-container>

                                <ng-container matColumnDef="schedule">
                                    <th mat-header-cell *matHeaderCellDef> Schedule </th>
                                    <td mat-cell *matCellDef="let schedule"> {{schedule.scheduleDisplayString}} </td>
                                </ng-container>

                                <ng-container matColumnDef="nextRunDate">
                                    <th mat-header-cell *matHeaderCellDef> Next Run Date </th>
                                    <td mat-cell *matCellDef="let schedule"> {{schedule.nextRunDate}} </td>
                                </ng-container>

                                <ng-container matColumnDef="lastRunDate">
                                    <th mat-header-cell *matHeaderCellDef> Last Run Date </th>
                                    <td mat-cell *matCellDef="let schedule"> {{schedule.lastRunDate}} </td>
                                </ng-container>

                                <ng-container matColumnDef="actions">
                                    <th mat-header-cell *matHeaderCellDef> Actions </th>
                                    <td mat-cell *matCellDef="let schedule">
                                        <button mat-icon-button (click)="editSchedule(schedule)">
                                            <mat-icon class="icon" title="Edit Schedule">edit</mat-icon>
                                        </button>
                                        <button mat-icon-button (click)="deleteSchedule(schedule.id)">
                                            <mat-icon class="icon red-icon" title="Delete Schedule">delete_forever</mat-icon>
                                        </button>
                                    </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            </table>
                        </mat-card-content>
                    </mat-card>
                </mat-tab>
                <mat-tab label="History">
                    <mat-card appearance="outlined">
                        <mat-card-content>
                            <h1 *ngIf="!hasScheduleHistory" class="center" style="color: lightgray">No Schedule History found</h1>
                            <table *ngIf="hasScheduleHistory" mat-table [dataSource]="historyItems" class="mat-elevation-z8">
                                <ng-container matColumnDef="status">
                                    <th mat-header-cell *matHeaderCellDef> </th>
                                    <td mat-cell *matCellDef="let item">
                                        <mat-icon *ngIf="item.status === scheduleRunStatusType.running" class="rotate-continous primary-color-icon" style="margin-right: 10px; vertical-align: middle;">settings_backup_restore</mat-icon>
                                        <mat-icon *ngIf="item.status === scheduleRunStatusType.failed" class="red-icon" style="margin-right: 10px; vertical-align: middle;">error_outline</mat-icon>
                                        <mat-icon *ngIf="item.status === scheduleRunStatusType.success" class="green-icon" style="margin-right: 10px; vertical-align: middle;">done</mat-icon>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="historyId">
                                    <th mat-header-cell *matHeaderCellDef> History Id </th>
                                    <td mat-cell *matCellDef="let item"> {{item.id}} </td>
                                </ng-container>

                                <ng-container matColumnDef="scheduleName">
                                    <th mat-header-cell *matHeaderCellDef> Schedule Name </th>
                                    <td mat-cell *matCellDef="let item"> {{item.scheduleName}} </td>
                                </ng-container>

                                <ng-container matColumnDef="startTime">
                                    <th mat-header-cell *matHeaderCellDef> Start Time </th>
                                    <td mat-cell *matCellDef="let item"> {{datePipe.transform(item.processStartDateTime, 'MM/dd/yyyy h:mm:ss a')}} </td>
                                </ng-container>

                                <ng-container matColumnDef="endTime">
                                    <th mat-header-cell *matHeaderCellDef> End Time </th>
                                    <td mat-cell *matCellDef="let item"> {{datePipe.transform(item.processEndDateTime, 'MM/dd/yyyy h:mm:ss a')}} </td>
                                </ng-container>

                                <tr mat-header-row *matHeaderRowDef="displayedColumnsHistory"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumnsHistory;"></tr>
                            </table>

                        </mat-card-content>
                    </mat-card>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
    </mat-card>
</div>